module.exports = __webpack_public_path__ + "59c6842a417fcecb239586d362adf2c2.pdf";